<template>
  <v-container>
    <v-row>
      <v-col cols="12" class="pt-0">
        <v-checkbox
          v-for="option in options"
          :key="option.value"
          v-model="localSelected"
          :value="option.value"
          :label="option.label"
          class="hyp-input-checkbox"
          dense
          hide-details
        ></v-checkbox>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import lodashIsEqual from "lodash/isEqual";
import {
  getPreference,
  savePreference,
} from "@/services/isosTravelTracker/travelTracker.service";
import { mapGetters } from "vuex";
import { MODULE_PREFIX_MAP } from "@/store";

const EMITTED_ACTIONS = {
  CHANGE: "change",
};

export default {
  name: "TravelTrackerTravelerTypeSelector",
  components: {},
  props: {
    selected: {
      type: Array,
    },
  },
  data() {
    return {
      options: [
        { value: "international", label: "International" },
        { value: "domestic", label: "Domestic" },
        { value: "expatriate", label: "Expatriate" },
      ],
      localSelected: [],
    };
  },
  async mounted() {
    this.localSelected =
      getPreference(this.$store, [], "travelerTypes", "travelTracker") ??
      this.localSelected;
  },
  computed: {
    ...mapGetters({
      resetMapIcons: MODULE_PREFIX_MAP + "resetMapIcons",
    }),
  },
  methods: {
    async resetSelection() {
      this.localSelected = [];
      savePreference(
        this.$store,
        this.localSelected,
        "travelerTypes",
        "travelTracker"
      );
      this.$emit(EMITTED_ACTIONS.CHANGE, this.localSelected);
    },
  },
  watch: {
    selected: {
      handler(newVal, oldVal) {
        if (lodashIsEqual(newVal, oldVal)) {
          this.localSelected = this.selected;
        }
      },
    },
    localSelected: {
      handler() {
        savePreference(
          this.$store,
          this.localSelected,
          "travelerTypes",
          "travelTracker"
        );
        this.$emit(EMITTED_ACTIONS.CHANGE, this.localSelected);
      },
    },
    resetMapIcons: {
      handler(newValue, oldValue) {
        if (oldValue !== newValue) {
          this.resetSelection();
        }
      },
    },
  },
};
</script>

<style scoped>
.hyp-input-checkbox {
  margin-top: 0;
}
</style>
